import React from "react"
import { components } from "react-select"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ClearIndicator = (props: any) => {
    return (
        <components.ClearIndicator {...props}>
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
                <g id="Group_2711" data-name="Group 2711" transform="translate(-671 -5740)">
                    <path
                        className="clear-icon"
                        id="Subtraction_10"
                        data-name="Subtraction 10"
                        d="M-4682.5-2869a7.508,7.508,0,0,1-7.5-7.5,7.508,7.508,0,0,1,7.5-7.5,7.508,7.508,0,0,1,7.5,7.5A7.508,7.508,0,0,1-4682.5-2869Zm0-6.2h0l2.68,2.679a.913.913,0,0,0,.651.268.911.911,0,0,0,.649-.268.912.912,0,0,0,.27-.65.912.912,0,0,0-.27-.65l-2.68-2.68,2.68-2.68a.915.915,0,0,0,.27-.652.91.91,0,0,0-.27-.649.911.911,0,0,0-.649-.268.913.913,0,0,0-.651.268l-2.68,2.68-2.682-2.68a.906.906,0,0,0-.649-.268.914.914,0,0,0-.65.268.913.913,0,0,0-.271.65.918.918,0,0,0,.271.651l2.68,2.68-2.68,2.68a.914.914,0,0,0-.271.651.914.914,0,0,0,.271.65.914.914,0,0,0,.65.268.906.906,0,0,0,.649-.268l2.681-2.679Z"
                        transform="translate(5361 8624)"
                        fill="#a1a1a1"
                    />
                </g>
            </svg>
        </components.ClearIndicator>
    )
}
